import { render, staticRenderFns } from "./ChangePasword.vue?vue&type=template&id=3c950f46&scoped=true&"
import script from "./ChangePasword.vue?vue&type=script&lang=js&"
export * from "./ChangePasword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c950f46",
  null
  
)

export default component.exports